import { api } from '@/api';
import { queryOptions } from '@tanstack/react-query';
import { getQueryKeysFactory } from './queryKeysFactory';

export const getScheduleQuery = (
  organizationId: string,
  scheduleId: string
) => {
  const { organizationKeys } = getQueryKeysFactory();

  return queryOptions({
    queryKey: organizationKeys.scheduleById(organizationId, scheduleId),
    queryFn: async () => {
      const response = await api.GetOrganizationSchedules({
        organizationId,
      });

      return response.data;
    },
    select: (data) => data.schedules.find((s) => s.scheduleId === scheduleId),
    enabled: !!organizationId && !!scheduleId,
  });
};
